"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBinaryExpression = void 0;
const common_1 = require("@finley-technologies/common");
const add_1 = require("./add");
const concatenate_1 = require("./concatenate");
const divide_1 = require("./divide");
const eq_1 = require("./eq");
const exponent_1 = require("./exponent");
const gt_1 = require("./gt");
const gte_1 = require("./gte");
const lt_1 = require("./lt");
const lte_1 = require("./lte");
const multiply_1 = require("./multiply");
const ne_1 = require("./ne");
const subtract_1 = require("./subtract");
const getBinaryExpression = (operator) => {
    switch (operator) {
        // Comparisons
        case '>':
            return gt_1.gt;
        case '<':
            return lt_1.lt;
        case '=':
            return eq_1.eq;
        case '>=':
            return gte_1.gte;
        case '<=':
            return lte_1.lte;
        case '<>':
            return ne_1.ne;
        // Arithmetic
        case '+':
            return add_1.add;
        case '-':
            return subtract_1.subtract;
        case '*':
            return multiply_1.multiply;
        case '/':
            return divide_1.divide;
        case '^':
            return exponent_1.exponent;
        // String manipulation
        case '&':
            return concatenate_1.concatenate;
        default:
            return (0, common_1.finleyAssertUnreachable)(operator, `Operator ${operator} not implemented`);
    }
};
exports.getBinaryExpression = getBinaryExpression;
//# sourceMappingURL=index.js.map